import * as ActionTypes from './action-types.constants';
export const open = () => ({
	type: ActionTypes.OPEN
})
export const close = () => ({
	type: ActionTypes.CLOSE
})
export const setContent = (content) => ({
	type: ActionTypes.SET_CONTENT,
	content
})
export const renderedContent = (container) => {
	return { 
		type: ActionTypes.RENDERED_CONTENT,
		container
	}
}